<template>
  <a-dialog v-model="show" width="800px" max-width="80vw" persistent scrollable>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ $t("agenda.lblTranscription") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text style="color: black">
        <v-row no-gutters>
          <v-col cols="12">
            <v-stepper v-model="transcript_step" vertical flat>
              <v-stepper-step :complete="transcript_step > 1" step="1">
                {{ $t("agenda.lblTranscriptionStep1") }}
                <span class="mx-2 mt-4 step1-notice"> {{ $t("agenda.lblTranscriptionStep1Notice") }}</span>
                </v-stepper-step
                >
              <v-stepper-content step="1">
                <v-row>
                  <v-col
                    cols="12"
                    v-cloak
                    @drop.prevent="addDropFile"
                    @dragover.prevent
                  >
                    <v-file-input
                      class="fileupload"
                      ref="inputUpload"
                      name="attachment"
                      :placeholder="$t('documents.dropFileHere')"
                      prepend-icon=""
                      prepend-inner-icon="mdi-paperclip"
                      lable="Upload file"
                      :accept="video_audio_types"
                      :multiple="false"
                      outlined
                      dense
                      @change="addUploadingFiles"
                      hide-details
                      @click:prepend-inner="iconClickable"
                    >
                    </v-file-input>
                    <v-divider v-if="transcriptFile"></v-divider>
                    <v-list
                      two-line
                      dense
                      v-if="transcriptFile"
                      class="file-list"
                    >
                      <v-list-item
                        link
                        :class="[
                          checkStatus(transcriptFile).status !== true
                            ? 'v-list-item--active'
                            : '',
                        ]"
                        :color="
                          checkStatus(transcriptFile).status !== true
                            ? '#990000'
                            : ''
                        "
                      >
                        <v-list-item-avatar>
                          <v-icon class="mdi-36px" color="grey lighten-1">
                            {{ showIcon(transcriptFile.name) }}
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ transcriptFile.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            >{{ formatBytes(transcriptFile.size) }} -
                            {{ transcriptFile.type }}</v-list-item-subtitle
                          >
                        </v-list-item-content>

                        <v-list-item-action
                          v-if="checkStatus(transcriptFile).status !== true"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="#990000 lighten-1"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-alert
                              </v-icon>
                            </template>
                            <span>{{
                              checkStatus(transcriptFile).message
                            }}</span>
                          </v-tooltip>
                        </v-list-item-action>

                        <v-list-item-action>
                          <v-btn icon @click="removeUploadingFile">
                            <v-icon
                              :color="
                                checkStatus(transcriptFile).status == true
                                  ? 'grey lighten-1'
                                  : 'error lighten-1'
                              "
                              >mdi-close</v-icon
                            >
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col cols="12" class="pt-0" v-if="false">
                    <a-btn
                      color="primaryDark"
                      v-if="transcriptFile && errorCount === 0"
                      @click="transcript_step = 2"
                    >
                      {{ $t("agenda.lblContinue") }}
                    </a-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-step :complete="transcript_step > 2" step="2">
                {{ $t("agenda.lblTranscriptionStep2") }}
              </v-stepper-step>

              <v-stepper-content step="2">
                <v-row>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-list
                      two-line
                      dense
                      v-if="transcriptFile"
                      class="file-list"
                    >
                      <v-list-item
                        link
                        class="v-list-item--active"
                        :color="
                          !checkStatus(transcriptFile).status
                            ? '#990000'
                            : '#808080'
                        "
                      >
                        <v-list-item-avatar>
                          <v-icon class="mdi-36px" color="grey lighten-1">
                            {{ showIcon(transcriptFile.name) }}
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ transcriptFile.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            >{{ formatBytes(transcriptFile.size) }} -
                            {{ transcriptFile.type }}</v-list-item-subtitle
                          >
                        </v-list-item-content>

                        <v-list-item-action
                          v-if="checkStatus(transcriptFile).status !== true"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="#990000 lighten-1"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-alert
                              </v-icon>
                            </template>
                            <span>{{
                              checkStatus(transcriptFile).message
                            }}</span>
                          </v-tooltip>
                        </v-list-item-action>

                        <v-list-item-action>
                          <v-btn icon @click="removeUploadingFile">
                            <v-icon
                              :color="
                                checkStatus(transcriptFile).status == true
                                  ? 'grey lighten-1'
                                  : 'error lighten-1'
                              "
                              >mdi-close</v-icon
                            >
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="d-flex flex-row" flat tile>
                      <v-row no-gutters>
                        <v-col
                          class=""
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <v-radio-group
                            hide-details=""
                            row
                            v-model="speakerRecognition"
                            class="pl-2"
                            style="height: 80px"
                          >
                            <v-radio
                              :label="$t('agenda.lblNoSpeakerRec')"
                            ></v-radio>
                            <v-radio>
                              <template v-slot:label>
                                <v-text-field
                                  row
                                  ref="speakerRef"
                                  v-model.number="noOfSpeaker"
                                  :label="$t('agenda.lblMaxSpeaker')"
                                  type="number"
                                  :min="1"
                                  :max="maxOfSpeaker"
                                  :rules="[(v) => validateSpeakerReqRule(v)]"
                                  required
                                  @keydown="filterKey"
                                  :maxlength="2"
                                  @input="filterNumberInput"
                                  pattern="/^-?\d+\.?\d*$/"
                                  onKeyPress="if(this.value.length==maxLength) { return false; }"
                                  filled
                                  dense
                                  style="min-width: 250px"
                                ></v-text-field>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-row no-gutters class="align-center">
                          <v-col cols="4 pl-2">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                  <v-checkbox
                                    v-bind="attrs"
                                    v-on="on"
                                    v-model="isChunkUpload"
                                    :label="$t('documents.lblLargeFileUpload')"
                                    dense
                                    hide-details
                                    class="mt-0"
                                    :ripple="false"
                                  ></v-checkbox>
                                </span>
                              </template>
                              <span>{{ $t("agenda.tipLargeFileUpload") }}</span>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="7">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <a-btn
                                  class="ma-2"
                                  color="primaryDark"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="uploadDocument"
                                  small
                                  :disabled="speakerRecognition === 1 && !$refs.speakerRef.validate()"
                                >
                                  {{ $t("agenda.lblUploadTranscript") }}
                                </a-btn>
                              </template>
                              <span>{{
                                $t("agenda.lblUploadTranscript")
                              }}</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-row>

                      <a-btn
                        text
                        color="primaryDark"
                        @click="transcript_step = 1"
                        class="ml-2"
                        v-if="false"
                      >
                        Back
                      </a-btn>
                    </v-card>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-step
                :complete="transcript_step > 3 || isCompleted"
                step="3"
              >
                {{ $t("agenda.lblTranscriptionStep3") }}
              </v-stepper-step>

              <v-stepper-content step="3" class="pb-0">
                <v-row v-if="!transcriptCsvFile">
                  <v-col cols="12" class="" align="right" v-if="isFaild">
                    <a-btn tile color="primaryDark" @click="addNewTranscript">
                      {{ $t("agenda.lblTranscription") }}
                    </a-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    class="subtitle-1 font-weight-medium"
                    align="center"
                  >
                    <span v-if="!isFaild">
                      {{ $t("msgTranscriptionQueueStatus") }}
                    </span>
                    <span v-else>
                      {{
                        $t(this.transcriptionDetail.transcript_error_message)
                      }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    align="center"
                    class="pl-12 pr-12"
                    v-if="!isFaild"
                  >
                    <v-progress-linear indeterminate></v-progress-linear>
                    <v-tooltip bottom v-if="isinProgress">
                      <template v-slot:activator="{ on, attrs }">
                        <a-btn
                          v-if="isinProgress"
                          color="primaryDark"
                          class="mt-6"
                          small
                          @click="deleteTranscript('reset')"
                          v-bind="attrs"
                          v-on="on"
                          ><span>{{ $t("lblReset") }}</span>
                        </a-btn>
                      </template>
                      <span> {{ $t("lblReset") }} </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" class="pt-0">
                    <v-card class="mt-0" outlined flat rounded="0">
                      <v-toolbar
                        color="neutralGray text--white"
                        density="compact"
                        style="height: 45px; color: #fff"
                        elevation="0"
                      >
                        {{ $t("agenda.lblTranscriptExcelFile") }}
                      </v-toolbar>
                      <v-list lines="two">
                        <v-list-item>
                          <v-list-item-icon class="mr-1">
                            <v-icon>mdi-file-document</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              transcriptCsvFile.fileName
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action class="ml-1">
                            <div>
                              <v-tooltip
                                bottom
                                v-if="generateTranscriptionPermission"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="generateTranscriptionPermission"
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    @click="documentDownload"
                                  >
                                    <v-icon color="neutralGray1" size="25"
                                      >mdi-download</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span>{{ $t("agenda.tipSaveDoc") }}</span>
                              </v-tooltip>

                              <v-tooltip
                                bottom
                                v-if="generateTranscriptionPermission"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="generateTranscriptionPermission"
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    @click="deleteTranscript('delete')"
                                  >
                                    <v-icon color="neutralGray1" size="25"
                                      >mdi-delete</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span>{{ $t("agenda.tipDeleteDoc") }}</span>
                              </v-tooltip>
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-stepper-content>
            </v-stepper>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              color="secondary"
              small
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnClose") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnClose") }} </span>
        </v-tooltip>
      </v-card-actions>
      <confirm-dialog ref="confirm"></confirm-dialog>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
      <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
    </v-card>
  </a-dialog>
</template>

<script>
import MessageSheet from "@/components/MessageSheet.vue";
import Loader from "@/components/Loader.vue";
import UploadFile from "@/components/documents/UploadFile.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapActions, mapState, mapGetters } from "vuex";

import { formatBytes, createUUID } from "../utils/util";
import {
  video_audio_types,
  fileIcons,
  MAX_UPLOAD_SIZE,
} from "../utils/constant";
import SignalRMixin from "../mixin/SignalRMixin";
import ChunkFileUpload from "../mixin/ChunkFileUpload";

export default {
  name: "GenerateTranscriptionStep",
  mixins: [SignalRMixin, ChunkFileUpload],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingObject: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  components: {
    MessageSheet,
    Loader,
    UploadFile,
    ConfirmDialog,
  },
  data() {
    return {
      speakerRecognition: 0,
      isChunkUpload: false,
      noOfSpeaker: 1,
      maxOfSpeaker: 35,
      transcriptFile: null,
      transcript_step: 1,
      displayMessage: false,
      message: "",
      messageType: "",
      Loaderloading: false,
      fileIcons,
      video_audio_types,
      transcriptCsvFile: null,
    };
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    ...mapState({
      transcriptionDetail: (state) => state.meeting.transcriptionDetail,
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    errorCount() {
      let count = 0;
      if (
        this.transcriptFile &&
        this.checkStatus(this.transcriptFile).status === false
      ) {
        count++;
      }
      return count;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    isFaild() {
      return (
        this.transcriptionDetail && this.transcriptionDetail.status === "Failed"
      );
    },
    isinProgress() {
      return (
        this.transcriptionDetail &&
        this.transcriptionDetail.status === "In Progress"
      );
    },
    isCompleted() {
      return (
        this.transcriptionDetail &&
        this.transcriptionDetail.status === "Completed"
      );
    },
    generateTranscriptionPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "GenerateTranscription"
        );
      }
      return false;
    },
  },
  watch: {
    transcriptionDetail(value) {
      this.setStatus(value);
    },
    speakerRecognition(val) {
      if(val === 0 && !this.$refs.speakerRef.validate()) this.setDefaultSpeaker();
    }
  },
  async mounted() {
    this.setStatus(this.transcriptionDetail);
    const target = `transcript_${this.meetingObject.id}`;
    await this.signalRInit(target);
    this.setDefaultSpeaker();
  },
  methods: {
    ...mapActions({
      createDocuments: "transcription/createDocuments",
      downloadDocumentAPI: "document/downloadDocument",
      setTranscriptionStatus: "meeting/setTranscriptionStatus",
      deleteTranscription: "transcription/deleteTranscription",
      resetTranscription: "transcription/resetTranscription",
    }),
    validateSpeakerReqRule(value) {
      return (
        (value.toString() !== "" && Number(value) > 0) ||
        this.$t("agenda.ruleSpeakerReq")
      )
    },
    setDefaultSpeaker() {
      this.noOfSpeaker = this.meetingObject.attendees.length || 1;
    },
    setStatus(transcriptionDetail) {
      if (transcriptionDetail && transcriptionDetail.status == "Completed") {
        this.transcript_step = 3;
        this.transcriptCsvFile = transcriptionDetail.document;
      } else if (
        transcriptionDetail &&
        transcriptionDetail.status == "In Progress"
      ) {
        this.transcript_step = 3;
        this.transcriptCsvFile = null;
      } else if (
        transcriptionDetail &&
        transcriptionDetail.status == "Failed"
      ) {
        this.transcript_step = 3;
        this.transcriptCsvFile = null;
      }
    },
    iconClickable() {
      this.$refs.inputUpload.$el.querySelector("input").click();
    },
    close() {
      this.$emit("input", false);
    },
    formatBytes,
    filesChange() {
      this.transcript_step = 2;
    },
    showIcon(fileName) {
      const extension = fileName.split(".").pop();
      return fileIcons[extension] || "mdi-file";
    },
    checkStatus(file) {
      const maxSize = MAX_UPLOAD_SIZE;
      let filesWithStatus = {
        filename: file.name,
      };
      if (!video_audio_types.includes(file.type)) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileErrorMsg", {
          filename: file.name,
        });
      } else if (file.size > maxSize) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileSizeErrorMsg", {
          maxsize: formatBytes(maxSize),
        });
      } else {
        filesWithStatus.status = true;
        filesWithStatus.message = "Success";
      }
      return filesWithStatus;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    fileError(err) {
      this.showMessageSheet(
        err.error + " File(s) Size Limit Exceeded",
        "error"
      );
    },
    addUploadingFiles,
    removeUploadingFile,
    addDropFile(e) {
      if (e.dataTransfer.files) {
        this.addUploadingFiles(e.dataTransfer.files[0]);
      }
    },
    addNewTranscript() {
      this.removeUploadingFile();
    },
    async uploadDocument() {
      this.Loaderloading = true;
      try {
        const formData = new FormData();
        const transcriptFilename = this.transcriptFile.name;
        const contentType = this.transcriptFile.type;
        const split = transcriptFilename.split(".");
        split.pop();
        const fileName = split.join(".") + ".csv";
        formData.append("speakerRecognition", this.speakerRecognition === 1);
        formData.append("maxSpeaker", Number(this.noOfSpeaker));
        formData.append("tenantId", this.selectedTenant);
        formData.append("documentId", createUUID());
        formData.append("meetingId", this.meetingObject.id);
        formData.append(
          "emailData[targetLinkLabel]",
          this.$t("agenda.meetingTargetLinkLabel")
        );
        formData.append("emailData[tenantName]", this.tenantName);
        formData.append(
          "emailData[subject]",
          this.$t("email.transcriptSubject")
        );
        formData.append(
          "emailData[message]",
          this.$t("email.transcriptMessage", {
            meeting: this.meetingObject.meetingName,
            tenant: this.tenantName,
            filename: fileName,
          })
        );
        formData.append(
          "emailData[emailOpenMeeting]",
          this.$t("email.emailOpenMeeting")
        );
        formData.append(
          "emailData[emailSupportML]",
          this.$t("email.emailSupportML")
        );
        formData.append(
          "emailData[emailPreHeader]",
          this.$t("email.emailPreHeader")
        );
        formData.append(
          "emailData[emailLblDear]",
          this.$t("email.emailLblDear")
        );
        formData.append(
          "emailData[resetSubject]",
          this.$t("email.resetSubject")
        );
        formData.append(
          "emailData[resetMessage]",
          this.$t("email.resetMessage", {
            meeting: this.meetingObject.meetingName,
            tenant: this.tenantName,
            filename: fileName,
          })
        );
        formData.append("emailData[AppLanguage]", this.selectedLang);
        formData.append(
          "template_id",
          process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID
        );
        formData.append("file", this.transcriptFile);

        formData.append("filename", transcriptFilename);
        formData.append("content_type", contentType);
        formData.append("chunk_upload", this.isChunkUpload);
        formData.append("document_type", "transcription_input");
        const response = this.isChunkUpload
          ? await this.uploadFileInChunks(this.transcriptFile, formData)
          : await this.createDocuments(formData);

        // const response = await this.createDocuments(formData);
        this.setTranscriptionStatus({
          document: response.data,
          status: "In Progress",
          transcript_error_message: "msgTranscriptionQueueStatus",
        });
        this.Loaderloading = false;
        this.transcript_step = 3;
        this.transcriptCsvFile = null;
        this.isChunkUpload = false;
      } catch (error) {
        console.error(error);
        this.Loaderloading = false;
      }
    },
    async documentDownload() {
      this.Loaderloading = true;
      try {
        const params = {
          documentId: this.transcriptCsvFile.id,
          filename: this.transcriptCsvFile.fileName,
        };
        const res = await this.downloadDocumentAPI(params);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        this.downloadMessage(url, this.transcriptCsvFile.fileName);
        this.Loaderloading = false;
      } catch (error) {
        console.error(error);
        this.Loaderloading = false;
      }
    },
    downloadMessage(url, name) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    async ConfirmBox(action) {
      let heading = this.$t("agenda.hDeleteMessage");
      let label = this.$t("agenda.lblDeleteMessage");
      if (action == "reset") {
        heading = this.$t("agenda.hTranslateReset");
        label = this.$t("agenda.translateResettMessage");
      }
      if (await this.$refs.confirm.open(heading, label, { width: 500 })) {
        return true;
      }
    },
    async deleteTranscript(action) {
      this.setDefaultSpeaker();
      const answer = await this.ConfirmBox(action);
      if (answer) {
        this.Loaderloading = true;
        try {
          let response = null;
          if (action === "reset") {
            const resetData = {
              meetingid: this.meetingObject.id,
              email_data: {
                message: this.$t("email.resetMessage", {
                  meeting: this.meetingObject.meetingName,
                  tenant: this.tenantName,
                  filename: this.transcriptionDetail.document.fileName,
                }),
                subject: this.$t("email.resetSubject"),
                tenantName: this.tenantName,
                emailSupportML: this.$t("email.emailSupportML"),
                emailPreHeader: this.$t("email.emailPreHeader"),
                targetLinkLabel: this.$t("agenda.meetingTargetLinkLabel"),
                emailOpenMeeting: this.$t("email.emailOpenMeeting"),
                template_id: process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID,
                app_language: this.selectedLang,
                label_dear: this.$t("email.emailLblDear"),
              },
            };
            response = await this.resetTranscription(resetData);
          } else {
            response = await this.deleteTranscription(this.meetingObject.id);
          }

          if (response.status) {
            let errormsg = this.$t("agenda.msgTranslateDeleteSuccessMessage");
            if (action === "reset") {
              errormsg = this.$t("agenda.msgTranslatAbortSuccessMessage");
            }
            this.showMessageSheet(errormsg, "success");
            this.resetTranscriptionData();
          } else {
            this.showMessageSheet(this.$t("agenda.commentFaildMsg"), "error");
          }
          this.Loaderloading = false;
        } catch (error) {
          console.error(error);
          this.Loaderloading = false;
        }
      }
    },
    signalRInit,
    resetTranscriptionData,
    filterKey,
    filterNumberInput,
  },
};
function filterKey(e) {
  const key = e.key;
  if (key === ".") return e.preventDefault();
  if (key === "e") return e.preventDefault();
  if (key === "-") return e.preventDefault();
}
function filterNumberInput(e) {
  if (Number(e) > Number(this.maxOfSpeaker))
    this.noOfSpeaker = this.maxOfSpeaker;
}
function resetTranscriptionData() {
  this.setTranscriptionStatus(null);
  this.transcript_step = 1;
  this.isChunkUpload = false;
  this.transcriptCsvFile = null;
  this.transcriptFile = null;
  this.$refs.inputUpload.$refs.input.value = null;
  this.$refs.inputUpload.reset();
}
async function signalRInit(target) {
  try {
    this.signalConnection.on(target, async (res) => {
      if (res.status === "Deleted" || res.status === "Reset") {
        this.resetTranscriptionData();
      }
      if (res.status === "In Progress") {
        this.setStatus("In Progress");
      }
      if (res.status === "Completed") {
        this.setStatus("In Progress");
      }
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {
    //console.log(error);
  }
}
function addUploadingFiles(file) {
  if (file) {
    this.transcriptFile = file;
    this.$refs.inputUpload.reset();
    if (this.checkStatus(this.transcriptFile).status === true) {
      this.transcript_step = 2;
    }
  }
}
function removeUploadingFile() {
  this.setDefaultSpeaker();
  this.transcriptFile = null;
  this.isChunkUpload = false;
  this.$refs.inputUpload.$refs.input.value = null;
  this.$refs.inputUpload.reset();

  this.transcript_step = 1;
}
</script>

<style scoped>
.error-element {
  color: var(--v-error-base) !important;
}
::v-deep .v-toolbar__content {
  height: 45px !important;
}

::v-deep .fileupload {
  padding-top: 0 !important;
  margin-top: 0 !important;
  color: #990000 !important;
}
::v-deep.v-text-field--outlined .v-input__slot {
  border: dashed 1px var(--v-neutralGray1-base) !important;
}
::v-deep.v-text-field--outlined fieldset {
  border: none;
}
.step1-notice{
  font-size: 12px;
  line-height: 16px;
}
</style>